import $ from 'cash-dom';
// Test git submodule update

export function validateForm(formId) {
    let error = false;

    $(`#${formId} input, #${formId} select`).each((i, e) => {
        $(e).data('error', '');
        $(e).parent().removeClass('error');
        if ($(e).val()) {
            var curVal = $(e).val().toString().trim().replace(/[\x00-\x1F\x7F-\x9F]/g, "");
        }
        if (!curVal && $(e)[0].required) {
            let action = 'nhập';
            if ($(e)[0].tagName === 'SELECT') {
                action = 'chọn';
            }
            $(e).parent().addClass('error');
            error = `Vui lòng ${action} ${$(e).data('name')}`;
            $(e).siblings('.w-error-log').html(error);
            $(e).data('error', error);
            $(e)[0].scrollIntoView();
            return error;
        }
        if (curVal && $(e).hasClass('w-phone') && !validatePhone(curVal)) {
            $(e).parent().addClass('error');
            error = `Số điện thoại không hợp lệ`;
            $(e).siblings('.w-error-log').html(error).css('opacity', 1);
            $(e).data('error', error)
            $(e)[0].scrollIntoView();
            return error;
        }
        if (curVal && ($(e).hasClass('w-email') || $(e).attr('type') === 'email') && !validateEmail(curVal)) {
            $(e).parent().addClass('error');
            error = `Email không đúng định dạng`;
            $(e).siblings('.w-error-log').html(error).css('opacity', 1);
            $(e).data('error', error)
            $(e)[0].scrollIntoView();
            return error;
        }
    })
    return error
}

export function validateEmail(email) {
    const regex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return regex.test(email);
}

export function validatePhone(text) {
    // var phoneformat = /^0\d{9}$/g;
    const phoneformat = /((^(\+84|84|0|0084){1})(3|5|7|8|9))+([0-9]{8})$/;
    // var phoneformat = /^[+]?(1\-|1\s|1|\d{3}\-|\d{3}\s|)?((\(\d{3}\))|\d{3})(\-|\s)?(\d{3})(\-|\s)?(\d{4})$/g;
    if (text.match(phoneformat)) {
        return true;
    }
    return false
}

export function readForm(formId) {
    const data = {};
    $(`#${formId} input, #${formId} select`).each((i, e) => {
        var key = $(e).attr("name");
        var value = $(e).val();
        if (key == "name") {
            value = $(e)
                .val()
                .toString()
                .trim()
                .replace(/[\x00-\x1F\x7F-\x9F]/g, "");
        }
        if (data["phone"] == "") {
            delete data["phone"];
        }
        data[key] = value;
    });

    if (data.hasOwnProperty('phone')) {
        if (data.phone.charAt(0) == '0') {
            // console.log('get phone đầu = 0');
            let oldPhoneString = data.phone.substring(1);
            data.phone = '+84' + oldPhoneString;
        }
    }
    // console.log('data');
    return data;
}


export function mergeClaimData(form, user, data) {
    if (!data) data = {};
    user.name = user.name || "anonymous";
    let metaString = '';
    const realDbField = ['name', 'email', 'phone', 'address', 'identity', 'password'];
    const keys = Object.keys(form);

    // convert meta -> add_data_1
    const metaStr = data.meta || '';
    const metaLines = metaStr.split('&');
    const meta = {}
    metaLines.forEach(line => {
        const [key, value] = line.split('=');
        meta[key] = value;
        const target = keys.find(k => form[k] && form[k].name == key);
        console.log('findTarget', {
            key,
            value,
            target
        })
        if (target) {
            data[target] = value;
        }
    })
    const mergedData = Object.assign({}, user, data)
    console.log({ form, user, data, meta });

    for (let key in mergedData) {
        if (!mergedData.hasOwnProperty(key) || !mergedData[key]) {
            continue;
        }
        if (!form[key] || !form[key].enabled) {
            continue;
        }

        if (!realDbField.includes(key)) {
            if (metaString) {
                metaString += '&';
            }
            var dataField = ['add_data_1', 'add_data_2', 'add_data_3', 'add_data_4'];
            console.log('form[key].name', form[key].name, typeof form[key].name);
            if (dataField.includes(key)) {
                console.log('have merge add_data');
                metaString += form[key].name + '=' + mergedData[key];
            }
        }
        if (key === "name") {
            mergedData[key] = mergedData[key]
                .toString()
                .trim()
                .replace(/[\x00-\x1F\x7F-\x9F]/g, "");
        }
    }
    if (metaString) {
        mergedData.meta = metaString;
    }
    return mergedData;
}


export function handleInfoForm(formId, callback) {
    const validateError = validateForm(formId);
    const formData = readForm(formId);

    const data = Object.assign({
        meta: ''
    }, formData);

    // console.log('data handle', data);

    // append form data to userInfo, ajaxSetup to set Auth header for every request

    callback(validateError, data);
}